import { render, staticRenderFns } from "./WhatsappDetail.vue?vue&type=template&id=0f51771b&"
import script from "./WhatsappDetail.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports